import React from 'react';
import GeneralInstructionCard from './GeneralInstructionCard';

function index(props) {
    return (
        <GeneralInstructionCard/>
    );
}

export default index;